import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';

import { getInitialsFromName } from '@ts-core/utils/utils';

const AddProfessorToCourse = (props) => {
  const { professors, onAddProfessor } = props;
  return (
    <Box width="100%">
      <List>
        {professors.map((professor) => (
          <Box key={professor.id}>
            <ListItem button onClick={() => onAddProfessor(professor)}>
              <ListItemAvatar>
                <Avatar alt={professor.name}>{getInitialsFromName(professor.name)}</Avatar>
              </ListItemAvatar>
              <ListItemText primary={professor.name} secondary={professor.email} />
            </ListItem>
            <Divider />
          </Box>
        ))}
      </List>
    </Box>
  );
};

AddProfessorToCourse.propTypes = {
  professors: PropTypes.array.isRequired,

  onAddProfessor: PropTypes.func.isRequired,
};

export default AddProfessorToCourse;
